import Vue from 'vue'
import Vuetify from 'vuetify'

import VueMeta from 'vue-meta'
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})

//import VueCountdownTimer from 'vuejs-countdown-timer';
//Vue.use(VueCountdownTimer);

// import VuePlyr from 'vue-plyr';
// import 'vue-plyr/dist/vue-plyr.css';
// Vue.use(VuePlyr)


//import VueCoreVideoPlayer from 'vue-core-video-player'
//Vue.use(VueCoreVideoPlayer)


import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
Vue.use(Vuetify)

import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

Vue.component('VueSlickCarousel', VueSlickCarousel);

const opts = {
    icons: {
        iconfont: 'mdi', // default - only for display purposes
    },
}

export default new Vuetify(opts)